module.exports = __webpack_public_path__ + "img/secced.30f1eb90.png";